// libraries
import * as React from "react";
import { QueryRenderer, ReadyState } from "react-relay";
// event scheduler imports
import { EventScheduler } from "./EventScheduler";
import { eventSchedulerQuery } from "./EventScheduler.gql";
// util
import { handleReadyStateError } from "#webapp/src/util/relay.util";
import { getCurrentEnvironment } from "../../state/relay-environment";

type Props = {
  onAttendeeChange?: (calendarIds: string[]) => void;
};

export const EventSchedulerRenderer = ({ onAttendeeChange }: Props) => (
  <QueryRenderer
    environment={getCurrentEnvironment()}
    query={eventSchedulerQuery}
    variables={{ calendarIds: [] }}
    cacheConfig={{ force: true }}
    render={(readyState: ReadyState) => {
      const viewer = readyState.props && readyState.props.viewer;

      // check for error or show a loader for first load
      if (readyState.error) {
        handleReadyStateError(readyState.error, "EventSchedulerRenderer");
        return;
      }

      if (!viewer) {
        return;
      }

      return <EventScheduler viewer={viewer} onAttendeeChange={onAttendeeChange} />;
    }}
  />
);
